import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import React, { useRef } from 'react';
import { Select } from '../../../ui/Select';
import { NewRadioButton } from '../../../NewRadioButton';
import { LeasedFilterContainer } from './styled';
import { LEASED_TYPES } from '../../../../utils/helpers/constants';
import { FilterFieldProps, SelectRefType } from '../types';

export const LeasedFilter: React.FC<FilterFieldProps> = ({
  submitOnChange
}) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change, submit } = useForm();

  const selectRef = useRef<SelectRefType>(null);

  const leasedValue = values?.leased;
  const findLeasedValue = type => type.value === leasedValue;
  const selectedValue = LEASED_TYPES.find(findLeasedValue)?.name;

  const handleChangeOption = (value: string) => {
    change('leased', value);

    if (selectRef.current) {
      selectRef.current?.closePopover();
    }

    if (submitOnChange) submit();
  };

  return (
    <Select
      ref={selectRef}
      placeholder=""
      value={t(selectedValue || '')}
      cypress="new-search-leased-filter"
      width={165}
      modalTitle={t('search.filters.dealType')}
      modalCypress="filter-modal"
    >
      <LeasedFilterContainer>
        {LEASED_TYPES.map(type => (
          <NewRadioButton
            key={type.id}
            data={{
              id: type.value,
              name: t(type.name)
            }}
            currentValue={leasedValue}
            onChangeHandler={() => handleChangeOption(type.value)}
            name={type.name}
            cypress={type.id}
            stat={type.id}
          />
        ))}
      </LeasedFilterContainer>
    </Select>
  );
};
